import React from 'react';
import './LoadingSpinner.scss';

const LoadingSpinner = ({ 
  message = 'Loading...', 
  size = 'medium',
  type = 'spinner',
  fullscreen = false 
}) => {
  const getSpinnerContent = () => {
    switch (type) {
      case 'dots':
        return (
          <div className={`loading-dots loading-dots--${size}`}>
            <div className="dot1"></div>
            <div className="dot2"></div>
            <div className="dot3"></div>
          </div>
        );
      
      case 'pulse':
        return <div className={`loading-pulse loading-pulse--${size}`}></div>;
      
      case 'bounce':
        return (
          <div className={`loading-bounce loading-bounce--${size}`}>
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        );
      
      default:
        return <div className={`loading-spinner-circle loading-spinner-circle--${size}`}></div>;
    }
  };

  const containerClass = `loading-container ${fullscreen ? 'loading-container--fullscreen' : ''}`;

  return (
    <div className={containerClass}>
      <div className="loading-content">
        {getSpinnerContent()}
        {message && <p className="loading-message">{message}</p>}
      </div>
    </div>
  );
};

// Skeleton loading components
export const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton-line skeleton-line--title"></div>
    <div className="skeleton-line skeleton-line--subtitle"></div>
    <div className="skeleton-line skeleton-line--content"></div>
    <div className="skeleton-line skeleton-line--content skeleton-line--short"></div>
  </div>
);

export const SkeletonList = ({ items = 3 }) => (
  <div className="skeleton-list">
    {Array.from({ length: items }, (_, index) => (
      <div key={index} className="skeleton-list-item">
        <div className="skeleton-avatar"></div>
        <div className="skeleton-content">
          <div className="skeleton-line skeleton-line--title"></div>
          <div className="skeleton-line skeleton-line--subtitle"></div>
        </div>
      </div>
    ))}
  </div>
);

export const SkeletonDashboard = () => (
  <div className="skeleton-dashboard">
    <div className="skeleton-header">
      <div className="skeleton-line skeleton-line--title"></div>
      <div className="skeleton-line skeleton-line--subtitle skeleton-line--short"></div>
    </div>
    <div className="skeleton-grid">
      {Array.from({ length: 6 }, (_, index) => (
        <SkeletonCard key={index} />
      ))}
    </div>
  </div>
);

// Progressive loading component
export const ProgressiveLoader = ({ 
  children, 
  fallback, 
  delay = 200,
  timeout = 10000 
}) => {
  const [showFallback, setShowFallback] = React.useState(false);
  const [isTimeout, setIsTimeout] = React.useState(false);

  React.useEffect(() => {
    const delayTimer = setTimeout(() => {
      setShowFallback(true);
    }, delay);

    const timeoutTimer = setTimeout(() => {
      setIsTimeout(true);
    }, timeout);

    return () => {
      clearTimeout(delayTimer);
      clearTimeout(timeoutTimer);
    };
  }, [delay, timeout]);

  if (isTimeout) {
    return (
      <div className="loading-timeout">
        <p>Loading is taking longer than expected...</p>
        <button onClick={() => window.location.reload()}>
          Reload Page
        </button>
      </div>
    );
  }

  return showFallback ? fallback : null;
};

export default LoadingSpinner;